module.exports = __webpack_public_path__ + "static/media/GL.1a0d165c.png";